import { Outlet } from "react-router-dom";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";
import { Button } from "@dealer-center/core-components";

export const RequireInternalUser = () => {
  const { data: userEntity, isLoading } = useGetUser();
  const hasAccess = userEntity?.internal;
  if (!hasAccess && !isLoading)
    return (
      <>
        <p>You do not have access</p>
        <Button
          analyticsConfiguration={{
            eventName: ""
          }}
          onClick={() => {
            const currentDomain = window.location.origin;
            const controlCenterUrl = `${currentDomain}/welcome`;
            window.location.href = controlCenterUrl;
          }}
        >
          Go to ControlCenter
        </Button>
      </>
    );
  return <Outlet />;
};
